import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { CoachLayoutResponse } from "../../Orchestrator/Types/Types/Checkout/Seating/CoachLayoutResponse";
import { FloorPlanIconResponse } from "../../Orchestrator/Types/Types/Checkout/Seating/FloorPlanIconResponse";
import { PlaceMapRequest, PlaceMapResponse } from "../../Orchestrator/Types/Types/Checkout/Seating/PlaceMap";

export async function getPlaceMapAvailability(params: PlaceMapRequest, showLoader: boolean = true): Promise<IApiResponse<PlaceMapResponse>> {
    const queryParams = new URLSearchParams({
        contextType: params.contextType,
        contextId: params.contextId,
        resourceId: params.resourceId,
        resourceType: params.resourceType
    });
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.placeMapAvailability}?${queryParams.toString()}`;
    return await apiRequest<PlaceMapResponse>(endpoint, 'GET', {}, "none", undefined, undefined, showLoader);
}

export async function getCoachLayouts(layoutId: string): Promise<IApiResponse<CoachLayoutResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.coachLayout}/${layoutId}`;
    return await apiRequest<CoachLayoutResponse>(endpoint, 'GET');
}

export async function getFloorPlanIcons(): Promise<IApiResponse<FloorPlanIconResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.floorPlanIcons}`;
    return await apiRequest<FloorPlanIconResponse>(endpoint, 'GET');
}


